import Reveal from "@/components/site/Reveal";
import ExpandableCard from "@/components/site/ExpandableCard";
import { openLead } from "@/lib/site";

const PATHS = [
  {
    id: "percorso-apertura",
    name: "Apri la tua struttura",
    tagline: "Per chi parte da zero o è in mezzo ai lavori: dall'idea all'apertura.",
    details: [
      "Fattibilità del progetto: i numeri attesi prima di spendere",
      "Progettazione degli spazi con Massimiliano, architetto",
      "Burocrazia e pratiche con Valerio, commercialista",
      "Avvio dell'attività: canali, prezzi e calendario pronti dal giorno uno",
      "Un solo interlocutore dall'inizio alla fine",
    ],
    owner: "Il team al completo: Luciano, Massimiliano, Valerio",
  },
  {
    id: "percorso-yu-setup",
    name: "Partenza assistita",
    tagline: "La partenza completa, per chi apre o riparte da zero.",
    details: [
      "Sopralluogo incluso: veniamo a vedere la struttura di persona",
      "Strategia e prezzi costruiti sulla tua zona",
      "Annunci e canali impostati da zero",
      "Calendario e tariffe del primo anno",
      "Ti seguo finché tutto gira da solo",
    ],
    owner: "Luciano",
  },
  {
    id: "percorso-yu-follow",
    name: "Gestione continua",
    tagline: "Una persona che segue la tua struttura ogni giorno.",
    details: [
      "Prezzi aggiornati ogni giorno, in base a chi cerca casa nella tua zona",
      "App per calendari e prezzi inclusa, senza costi aggiuntivi: tutto allineato su Booking e Airbnb",
      "Mi muovo prima dell'alta stagione, non dopo",
      "Ogni mese un report semplice: com'è andata e cosa faccio dopo",
      "Seguo poche strutture alla volta, solo dove posso fare la differenza",
    ],
    owner: "Luciano, di persona — numero limitato di strutture",
    steps: {
      title: "Il metodo, in 5 passi",
      items: [
        { name: "Analisi", text: "Dove sei oggi: posizionamento, concorrenti, domanda nella tua zona." },
        { name: "Strategia", text: "Prezzi costruiti sui tuoi numeri: occupazione e ricavi su insieme." },
        { name: "Presenza online", text: "Booking, Airbnb e sito sistemati: trovato bene, presentato bene." },
        { name: "Ogni giorno", text: "Prezzi e calendario aggiustati tutti i giorni, mai a intuito." },
        { name: "Ogni anno meglio", text: "I dati accumulati rendono la stagione dopo più precisa." },
      ],
    },
  },
];

export default function Tailored() {
  return (
    <section id="percorso-su-misura" data-testid="tailored-section" className="scroll-mt-20 border-b border-[#2A241F] bg-[#16110E] py-12 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="section-kicker">Percorso su misura</p>
          <h2 className="mt-4 max-w-3xl font-heading text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#FAF7F2] sm:text-4xl lg:text-6xl">
            Non per tutti. Apposta.
          </h2>
          <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-[#C4BBB0]">
            Questa è la parte centrale di YieldUp: non ti vendo uno strumento da usare da solo — mi prendo la responsabilità dei tuoi numeri, ogni giorno.
          </p>
          <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-[#C4BBB0]">
            Prima guardo la tua struttura, poi ti dico se ha senso. Se non posso aiutarti, te lo dico subito.
          </p>
        </Reveal>

        <div className="mt-14 grid items-stretch gap-6 lg:grid-cols-2">
          {PATHS.map((p, i) => {
            const spotlight = p.id === "percorso-yu-follow";
            const card = (
              <ExpandableCard
                {...p}
                index={i + 1}
                badge={p.id === "percorso-yu-follow" ? "da 250 €/mese" : "Su valutazione"}
                ctaLabel="Prenota una chiamata"
                ctaTestId={`cta-${p.id}`}
                onCta={() => openLead(p.name)}
              />
            );
            return (
              <Reveal key={p.id} delay={i * 0.07} className={spotlight ? "h-full lg:col-span-2" : "h-full"}>
                {spotlight ? (
                  <div className="relative mt-3 h-full lg:mt-0">
                    <span className="absolute -top-3 left-6 z-10 rounded-full bg-[#E05A2C] px-4 py-1 font-mono text-xs uppercase tracking-widest text-white sm:text-xs">
                      Il cuore di YieldUp
                    </span>
                    <div className="h-full border border-[#E05A2C] p-1.5 shadow-[0_0_50px_rgba(224,90,44,0.14)]">
                      {card}
                    </div>
                  </div>
                ) : (
                  card
                )}
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <p data-testid="no-lockin-line" className="mt-10 flex max-w-3xl items-center gap-4 border border-[#4D2C20] bg-[#2B1B15] px-6 py-5 text-sm leading-relaxed text-[#FAF7F2] sm:text-base">
            <span className="shrink-0 font-heading font-black text-[#E05A2C]">—</span>
            Nessun vincolo: disdici quando vuoi, con 30 giorni di preavviso.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
